import cns from 'classnames'
import { useMedia } from 'react-use'
import { Button } from 'shared/ui/controls/Button'
import { Title } from 'shared/ui/common/Title'

import { ReactComponent as LogoSmall } from 'assets/logo-small.svg'
import { ReactComponent as CloseSVG } from 'assets/close.svg'
import planet from 'assets/planet.png'

import s from './AppWrap.module.scss'

type Props = {
  className?: string
  children?: React.ReactNode
}

export function AppWrap({ className, children }: Props) {
  const isMobile = useMedia('(max-width: 768px)')

  if (isMobile) {
    return (
      <div className={s.mobilePlaceholder}>
        <img src={planet} alt="" />
        <div className={s.roundGradient} />
        <div className={s.header}>
          <LogoSmall />
          <a href="/">
            <Button isSquare fashion="glass" className={s.close}>
              <CloseSVG />
            </Button>
          </a>
        </div>
        <Title className={s.title} isCentered>
          Please use <br /> rocifi <br /> on desktop
        </Title>
      </div>
    )
  }

  return <div className={cns(s.wrap, className)}>{children}</div>
}
